import { render, staticRenderFns } from "./TerapieComplicanzeEditComponent.vue?vue&type=template&id=36f4e5ed"
import script from "./TerapieComplicanzeEditComponent.vue?vue&type=script&lang=js"
export * from "./TerapieComplicanzeEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports